import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import localData from "@/store/utils/localdata";

const state = {
	userId: localData.getItem("user-id") || "",
	token: localData.getItem("user-token") || "",
	status: "",
};

export default {
	state,
	getters,
	actions,
	mutations,
};
